export default __webpack_public_path__ + "static/main-5b27215d184bf228d7dabbc28341a440.jpeg";